"use strict";

;
(function (BlogNavigation, $) {
  BlogNavigation.init = function () {
    // Add class to anchor tag which matches URL
    // Server-side Liquid is incapable of doing this

    // CHECK IF CONTAINER EXISTS
    if ($('.blog-links-container').length) {
      var blogs = '/blogs/';
      var url = window.location.href.replace(/.*(\/blogs\/)/g, '');
      var active = blogs + url;
      $('.blog-links-container .link').each(function () {
        if ($(this).attr('href') === active) {
          $(this).addClass('active');
        }
      });
    }
  };
})(window.BlogNavigation = window.BlogNavigation || {}, jQuery, undefined);